import { Pipe, PipeTransform } from '@angular/core';
import { formatKlDateValue, formatKlTimeOnly } from '../utils/kl-date-format';

/**
 * Same contract as legacy `klDate`: `(value, dateTime?, onlyTime?)`.
 */
@Pipe({
  name: 'klDate',
  standalone: false,
})
export class KlDatePipe implements PipeTransform {
  transform(value: unknown, dateTime: boolean = false, onlyTime: boolean = false): string {
    if (value == null || value === '') return '';
    if (onlyTime) return formatKlTimeOnly(value);
    return formatKlDateValue(value, dateTime);
  }
}
